import _extends from "@babel/runtime-corejs3/helpers/extends";
import { features } from '@kdcloudjs/table';
function useTreeMode(pipeline, treeMode) {
  if (treeMode) {
    pipeline.use(features.treeMode(_extends({}, treeMode)));
  }
}
export default useTreeMode;